const listeners: Record<string, (msg: string) => void> = {};

export function addErrorListener(id: string, listener: (msg: string) => void): void {
	listeners[id] = listener;
}
export function logError(msg: string): void {
	Object.values(listeners).forEach((l) => l(msg));
}
